import 'custom-event-polyfill';
import { constants, releaseConfig } from '../../common/common.js';
// const constants = require('../../../config/constants');
const cardsAcrossWindow = constants.cardsAcrossWindow;
const screenSizeFactor = 1;
const hundred = 100;
const shrinkFactor = constants.mobileCarouselShrinkPercentage / hundred;

let shrinkCardIndexes = [];
let selectedCardIndexes = [];
const mobileCarousels = document.querySelectorAll('.mobile-carousel');
let carouselData = new Array(mobileCarousels.length);
// const releaseConfig = require('../../../config/releaseConstants');

export default class MobileCarousels {

    static addRemoveClassesForDoubleAndSingleMobileCarousels() {
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        for (let i = 0; i  < mobileCarousels.length; i++) {
            const carousel = mobileCarousels[i];
            const items = carousel.querySelectorAll('.carousel-item');
            carousel.classList.remove('mobile-carousel-double');
            carousel.classList.remove('mobile-carousel-single');
            if (items.length === 1 + 1) {
                carousel.classList.add('mobile-carousel-double');
                items[0].firstElementChild.classList.add('left-card');
                items[1].firstElementChild.classList.add('right-card');
            }
            else if (items.length === 1) {
                carousel.classList.add('mobile-carousel-single');
            }
        }
    }

    static includes(array, item) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] === item) {
                return true;
            }
        }
        return false;
    }

    static selectedOffer(offer) {
        if (MobileCarousels.includes(offer.classList, 'selected-card')) {
            return true;
        }
        return false;
    }

    static getSelectedOfferIndex(offers) {
        for (let i = 0; i < offers.length; i++) {
            if (MobileCarousels.selectedOffer(offers[i])) {
                return i;
            }
        }
        return -1;
    }

    static setMobilePaginations() { // eslint-disable-line complexity
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        const mobilePaginations = document.querySelectorAll('.mobile-pagination');
        const totalMobileCarousels = mobileCarousels.length;
        const screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
        for (let i = 0; i < totalMobileCarousels; i++) {
            let offersInCarousel;
            if (mobileCarousels[i].firstElementChild.childElementCount > 2) { //eslint-disable-line no-magic-numbers
                offersInCarousel = mobileCarousels[i].firstElementChild.childElementCount / 2;//eslint-disable-line no-magic-numbers
            } else {
                offersInCarousel = mobileCarousels[i].firstElementChild.childElementCount;
            }

            if (releaseConfig.carouselPaginationLNG1118 && screenWidth >= constants.mdWindowBreakpoint
                && screenWidth < constants.lgWindowBreakpoint && offersInCarousel <= 2) {// eslint-disable-line no-magic-numbers
                mobilePaginations[i].classList.add('hide-balls-pagination');
                continue;
            } else {
                mobilePaginations[i].classList.remove('hide-balls-pagination');
            }

            mobilePaginations[i].innerHTML = '';
            for (let j = 0; j < offersInCarousel; j++) {
                mobilePaginations[i].innerHTML += '<div class="page-ball"></div>';
            }
            if (mobilePaginations[i].childElementCount === 1) {
                mobilePaginations[i].style.display = 'none';
            }
        }
    }

    static onScrollColourMobilePageBalls(index, offers, totalUniqueOffersInCarousel) {
        const selectedCardIndex = MobileCarousels.getSelectedOfferIndex(offers);
        const mobilePaginations = document.querySelectorAll('.mobile-pagination');
        const pageBalls = mobilePaginations[index].querySelectorAll('.page-ball');
        for (let j = 0; j < totalUniqueOffersInCarousel; j++) {
            if (j === selectedCardIndex % totalUniqueOffersInCarousel) {
                pageBalls[j].classList.remove('brand--light-grey');
                pageBalls[j].classList.add('brand--dark-grey');
            } else {
                pageBalls[j].classList.remove('brand--dark-grey');
                pageBalls[j].classList.add('brand--light-grey');
            }
        }
    }

    static setPageBallsColours() {
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        for (let i = 0; i < mobileCarousels.length; i++) {
            const mobileCarousel = mobileCarousels[i];
            const offers = mobileCarousel.querySelectorAll('.carousel-item');
            let totalUniqueOffersInCarousel;
            if (offers.length > 2) { //eslint-disable-line no-magic-numbers
                totalUniqueOffersInCarousel = offers.length / 2; //eslint-disable-line no-magic-numbers
            } else {
                totalUniqueOffersInCarousel = offers.length;
            }
            mobileCarousels[i].removeEventListener('scroll', () => {
                MobileCarousels.onScrollColourMobilePageBalls(i, offers, totalUniqueOffersInCarousel);
            });
            mobileCarousels[i].addEventListener('scroll', () => {
                MobileCarousels.onScrollColourMobilePageBalls(i, offers, totalUniqueOffersInCarousel);
            }, false);
        }
    }

    static getSelectedCardIndex(scrollLeft, carouselWidth, cardWidth) {
        return Math.floor((scrollLeft + carouselWidth / 2)  / cardWidth); //eslint-disable-line no-magic-numbers
    }

    static getShrinkingCardIndex(scrollLeft, carouselWidth, cardWidth) {
        return Math.floor((scrollLeft + carouselWidth / 2 + cardWidth / 2)  / cardWidth); //eslint-disable-line no-magic-numbers
    }

    static getWidth(element) {
        const style = window.getComputedStyle(element);
        const marginRight = parseInt(style.marginRight, 10);
        const marginLeft = parseInt(style.marginLeft, 10);
        const elementWidth = element.offsetWidth;
        return elementWidth + marginLeft + marginRight;
    }

    static resetCarouselData() {
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        selectedCardIndexes = [];
        shrinkCardIndexes = new Array(mobileCarousels.length);
        const ampleSlots = 20;
        for (let i = 0; i < ampleSlots; i++) {
            shrinkCardIndexes[i] = 0;
        }
        carouselData = new Array(mobileCarousels.length);
    }

    static calculateCarousel(carousel, mobileCarousels) {
        const items = carousel.querySelectorAll('.carousel-item');
        const cardWidth = MobileCarousels.getWidth(items[0]);
        let totalCards;
        if (items.length < cardsAcrossWindow) {
            totalCards = items.length;
        } else {
            totalCards = items.length /2; //eslint-disable-line no-magic-numbers
        }
        const carouselWidth = carousel.offsetWidth;
        const cardsWidth = cardWidth * totalCards;
        let initialSelectedCardIndex;
        if (items.length < cardsAcrossWindow) {
            initialSelectedCardIndex = 1;
        } else {
            initialSelectedCardIndex = totalCards;
        }
        const index = Array.prototype.indexOf.call(mobileCarousels, carousel);
        carouselData[index] =  {
            index: index,
            items: items,
            carouselWidth: carouselWidth,
            cardWidth: cardWidth,
            cardsWidth: cardsWidth,
            initialSelectedCardIndex: initialSelectedCardIndex,
            totalCards: totalCards
        };
    }

    static selectCard(carouselData) {
        for (let j = 0; j < carouselData.items.length; j++) {
            if (j === carouselData.totalCards) {
                j++;
            }
            carouselData.items[j].classList.remove('selected-card');
        }
        if (carouselData.totalCards > 2) { //eslint-disable-line no-magic-numbers
            carouselData.items[carouselData.totalCards].classList.add('selected-card');
        } else {
            carouselData.items[0].classList.add('selected-card');
        }
    }

    static makeCarousel(carousel) {
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        const index = Array.prototype.indexOf.call(mobileCarousels, carousel);
        MobileCarousels.calculateCarousel(carousel, mobileCarousels);
        if (carouselData[index].totalCards > 2) { //eslint-disable-line no-magic-numbers
            selectedCardIndexes[index] = carouselData[index].totalCards;
            carousel.scrollLeft = carouselData[index].cardsWidth - carouselData[index].carouselWidth / 2 + carouselData[index].cardWidth / 2; //eslint-disable-line no-magic-numbers
        } else {
            selectedCardIndexes[index] = 1;
            carousel.scrollLeft = 0;
        }
        this.selectCard(carouselData[index]);
        try {
            carousel.dispatchEvent(new CustomEvent('scroll'));
            return true;
        } catch (e) {
            return e;
        }
    }

    static onScrollForCarouselWithTwoCards(index, mobileCarousels) {
        const carousel = mobileCarousels[index];
        const cards = carousel.querySelectorAll('.card__container2');
        const items = carouselData[index].items;
        const cardWidth = carouselData[index].cardWidth;
        const totalCards = 2;
        const carouselWidth = carouselData[index].carouselWidth;
        const scrollLeft = carousel.scrollLeft;
        const currentSelectedCardIndex = MobileCarousels.getSelectedCardIndex(scrollLeft, carouselWidth, cardWidth, totalCards);
        const scrollLeftMax = carousel.scrollWidth - carousel.clientWidth;
        const proportionThroughScroll = (scrollLeftMax - scrollLeft) / scrollLeftMax;
        const scale = 1 - shrinkFactor * proportionThroughScroll;
        const scaleInverse = 1 - shrinkFactor * (1 - proportionThroughScroll);
        const mobilePaginations = document.querySelectorAll('.mobile-pagination');
        if (!isNaN(currentSelectedCardIndex) && currentSelectedCardIndex !== selectedCardIndexes[index]) {
            const oldSelectedCard = items[selectedCardIndexes[index]];
            oldSelectedCard.classList.remove('selected-card');
            items[currentSelectedCardIndex].classList.add('selected-card');
            selectedCardIndexes[index] = currentSelectedCardIndex;
        }
        const leftCard = cards[0];
        const rightCard = cards[1];
        if (carousel.scrollWidth >= carouselWidth + 10) { // eslint-disable-line no-magic-numbers
            leftCard.style.transform = 'scale(' + scaleInverse + ')';
            rightCard.style.transform = 'scale(' + scale + ')';
            leftCard.style.marginLeft = '16px';
            leftCard.style.marginRight = '4px';
            rightCard.style.marginRight = '16px';
            rightCard.style.marginLeft = '4px';
            mobilePaginations[index].style.display = 'block';
        } else {
            leftCard.style.transform = 'scale(' + 1 + ')';
            rightCard.style.transform = 'scale(' + 1 + ')';
            leftCard.style.marginLeft = 'auto';
            leftCard.style.marginRight = '12px';
            rightCard.style.marginRight = 'auto';
            rightCard.style.marginLeft = '12px';
            mobilePaginations[index].style.display = 'none';
        }
    }

    static addScrollListenerForCarouselWithTwoCards(index, mobileCarousels) {
        mobileCarousels[index].removeEventListener('scroll', () => {
            MobileCarousels.onScrollForCarouselWithTwoCards(index, mobileCarousels);
        });
        mobileCarousels[index].addEventListener('scroll', () => {
            MobileCarousels.onScrollForCarouselWithTwoCards(index, mobileCarousels);
        });
    }

    static calculateShrinkCardScale(proportionThroughShrinkCard) {
        return 1 - (1 - proportionThroughShrinkCard) * shrinkFactor;
    }

    static calculateGrowCardScale(proportionThroughShrinkCard) {
        return 1 - proportionThroughShrinkCard * shrinkFactor;
    }

    static scrollJumpForEndlessIllusion(items, currentSelectedCardIndex, totalCards, carousel, cardsWidth, forward) {
        items[currentSelectedCardIndex].style.transform = 'scale(' + (1 - shrinkFactor) + ')';
        items[currentSelectedCardIndex + (forward ? -1 : 1)].style.transform = 'scale(' + (1 - shrinkFactor) + ')';
        totalCards = forward ? -totalCards : totalCards;
        if (totalCards % (1 + 1)) {
            items[currentSelectedCardIndex + totalCards].style.transform = 'scale(1)';
        } else {
            items[currentSelectedCardIndex + totalCards].style.transform = 'scale(' + (1 - shrinkFactor / (1+1)) + ')';
            items[currentSelectedCardIndex + totalCards - 1].style.transform = 'scale(' + (1 - shrinkFactor / (1+1)) + ')';
        }
        carousel.scrollLeft = carousel.scrollLeft + (forward ? -cardsWidth : cardsWidth);
        currentSelectedCardIndex += totalCards;
    }

    static setScalesIfNotJumped(scrollJumped, shrinkCard, shrinkCardScale, growCard, growCardScale) {
        /* eslint-disable no-magic-numbers */
        /* eslint-disable no-useless-concat */
        if (!scrollJumped) {
            shrinkCard.style.transform = 'scale(' + shrinkCardScale + ')';
            shrinkCard.firstElementChild.style.boxShadow = '0 '+(2+(shrinkCardScale-0.9)*60)+'px '+'8px 0 hsla(0,0%,69%,1), 0 0 0 0 #000';
            growCard.style.transform = 'scale(' + growCardScale + ')';
            growCard.firstElementChild.style.boxShadow = '0 '+(2+(growCardScale-0.9)*60)+'px '+'8px 0 hsla(0,0%,69%,1), 0 0 0 0 #000';
        }
    }

    static onScrollForCarouselWithMoreThanTwoCards(index, mobileCarousels) {
        const carousel = mobileCarousels[index];
        const items = carouselData[index].items;
        const cardWidth = carouselData[index].cardWidth;
        const totalCards = carouselData[index].totalCards;
        const carouselWidth = carouselData[index].carouselWidth;
        const cardsWidth = carouselData[index].cardsWidth;
        const scrollLeft = carousel.scrollLeft;
        const currentShrinkCardIndex = MobileCarousels.getShrinkingCardIndex(scrollLeft, carouselWidth, cardWidth, totalCards);
        const currentSelectedCardIndex = MobileCarousels.getSelectedCardIndex(scrollLeft, carouselWidth, cardWidth, totalCards);
        const edgeOfAllCardsToCenterOfScreen = scrollLeft + carouselWidth / 2; //eslint-disable-line no-magic-numbers
        let scrollJumped = false;
        if (edgeOfAllCardsToCenterOfScreen >= cardsWidth * 3/2) { //eslint-disable-line no-magic-numbers
            MobileCarousels.scrollJumpForEndlessIllusion(items, currentSelectedCardIndex, totalCards, carousel, cardsWidth, true);
            scrollJumped = true;
        }
        if (edgeOfAllCardsToCenterOfScreen <= cardsWidth * 1/2) { //eslint-disable-line no-magic-numbers
            MobileCarousels.scrollJumpForEndlessIllusion(items, currentSelectedCardIndex, totalCards, carousel, cardsWidth, false);
            scrollJumped = true;
        }
        if (currentSelectedCardIndex !== selectedCardIndexes[index] ) {
            items[selectedCardIndexes[index]].classList.remove('selected-card');
            items[currentSelectedCardIndex].classList.add('selected-card');
            selectedCardIndexes[index] = currentSelectedCardIndex;
        }
        if (currentShrinkCardIndex !== shrinkCardIndexes[index]) {
            items[shrinkCardIndexes[index]].classList.remove('shrink-card');
            items[currentShrinkCardIndex].classList.add('shrink-card');
            shrinkCardIndexes[index] = currentShrinkCardIndex;
        }
        const proportionThroughShrinkCard = (edgeOfAllCardsToCenterOfScreen + cardWidth/(1+1)) % cardWidth / cardWidth;
        const shrinkCard = items[currentShrinkCardIndex];
        const growCard = items[currentShrinkCardIndex - 1];
        let shrinkCardScale = MobileCarousels.calculateShrinkCardScale(proportionThroughShrinkCard);
        let growCardScale = MobileCarousels.calculateGrowCardScale(proportionThroughShrinkCard);
        shrinkCardScale *= screenSizeFactor;
        growCardScale *= screenSizeFactor;
        MobileCarousels.setScalesIfNotJumped(scrollJumped, shrinkCard, shrinkCardScale, growCard, growCardScale);
    }

    static addScrollListenerForCarouselWithMoreThanTwoCards(index, mobileCarousels) {
        carouselData[index] = MobileCarousels.calculateCarousel(mobileCarousels[index], mobileCarousels);
        mobileCarousels[index].removeEventListener('scroll', () => {
            MobileCarousels.onScrollForCarouselWithMoreThanTwoCards(index, mobileCarousels);
        });
        mobileCarousels[index].addEventListener('scroll', () => {
            MobileCarousels.onScrollForCarouselWithMoreThanTwoCards(index, mobileCarousels);
        });
    }

    static sizeOfferCardsInNormalCarousels() {
        const carouselsNotWithTwoCards = document.querySelectorAll('.mobile-carousel:not(.mobile-carousel-double):not(.mobile-carousel-single)');
        for (let i = 0; i < carouselsNotWithTwoCards.length; i++) {
            const offers = carouselsNotWithTwoCards[i].querySelectorAll('.carousel-item');
            for (let j = 0; j < offers.length; j++) {
                offers[j].style.transform = 'scale(' + screenSizeFactor * (1 - shrinkFactor) + ')';
            }
        }
    }

    static addCorrectEventListenersForDifferentSizeCarousels() {
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        for (let i = 0; i < mobileCarousels.length; i++) {
            const carousel = mobileCarousels[i];
            const firstCarouselItem = carousel.querySelector('.carousel-item');
            if (firstCarouselItem) {
                MobileCarousels.calculateCarousel(mobileCarousels[i], mobileCarousels);
                if (carouselData[i].totalCards === 2) { //eslint-disable-line no-magic-numbers
                    MobileCarousels.addScrollListenerForCarouselWithTwoCards(i, mobileCarousels);
                } else if (carouselData[i].totalCards > 2) { //eslint-disable-line no-magic-numbers
                    MobileCarousels.addScrollListenerForCarouselWithMoreThanTwoCards(i, mobileCarousels);
                }
            }
        }
    }

    static containsItem(carousel) {
        const firstCarouselItem = carousel.querySelector('.carousel-item');
        return firstCarouselItem ? true : false;
    }

    static makeCarouselIfItContainsAnItem(carousel) {
        if (MobileCarousels.containsItem(carousel)) {
            MobileCarousels.makeCarousel(carousel);
            try {
                carousel.dispatchEvent(new CustomEvent('scroll'));
                return true;
            } catch (e) {
                return e;
            }
        }
        return true;
    }

    static makeMobileCarousels() {
        MobileCarousels.addRemoveClassesForDoubleAndSingleMobileCarousels();
        MobileCarousels.setMobilePaginations();
        MobileCarousels.setPageBallsColours();
        MobileCarousels.resetCarouselData();
        MobileCarousels.sizeOfferCardsInNormalCarousels();
        MobileCarousels.addCorrectEventListenersForDifferentSizeCarousels();
        const mobileCarousels = document.querySelectorAll('.mobile-carousel');
        for (let i = 0; i < mobileCarousels.length; i++) {
            try {
                if (getComputedStyle(mobileCarousels[i], null).display !== 'none') {
                    MobileCarousels.makeCarouselIfItContainsAnItem(mobileCarousels[i]);
                }
            } catch (e) {
                MobileCarousels.makeCarouselIfItContainsAnItem(mobileCarousels[i]);
            }
        }
    }
}
